import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingImage from '../../assets/images/loader.svg';
import ErrorPage from '../../containers/ErrorPage';
import TextMap from '../../helpers/TextMap';
import dataModel from '../../models/DataModel';

import './home.scss';

export class Home extends Component {

  constructor(props){
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleExpireyTimeout = this.handleExpireyTimeout.bind(this);
    this.handleWaitTimeout = this.handleWaitTimeout.bind(this);
    this.textMap = new TextMap();
  }

  componentWillUnmount() {
    if (this.expireyTimer) {
      clearTimeout(this.expireyTimer);
    }
    if (this.waitTimer) {
      clearTimeout(this.waitTimer);
    }
  }

  handleClick(e){
    if (this.props.type == 'transparent'){
      this.props.dataModel.inProgress = 0;
    }
  }

  handleExpireyTimeout() {
    window.location.reload(false);
    // this.expired = true
    // this.props.dataModel.displayHTTPError(this.message, "A timeout occurred while loading data.", true)
  }

  handleWaitTimeout() {
    let message = 'The action is taking a long time to complete.';
    if(this.props.type == 'pdf'){
      message = 'The action is taking a long time, but will download when complete.';
    }
    this.waiting = true;
    this.props.dataModel.displayHTTPError(this.message, message, false);
  }

  render() {
    if (this.props.catastrophicError) {
      return <ErrorPage catastrophicError={this.props.catastrophicError} />;
    }

    if (this.expireyTimer) {
      clearTimeout(this.expireyTimer);
    }
    if (this.waitTimer) {
      clearTimeout(this.waitTimer);
    }

    if (this.props.type != 'transparent' && this.props.type != 'pdf') {
      if (!this.expired) {
        this.expireyTimer = setTimeout(this.handleExpireyTimeout, this.props.timeout ? this.props.timeout : 20000);
      }
    }
    else {
      if (!this.waiting) {
        let waitTime = 30000;
        if(this.props.type == 'pdf'){
          waitTime = 60000;
        }
        this.waitTimer = setTimeout(this.handleWaitTimeout, waitTime);
      }
    }

    let classes;
    this.message = 'Loading Projects...';
    switch (this.props.type) {
    case 'transparent':
      this.message = 'A data request has been made';
      classes = 'transparent';
      break;
    case 'pdf':
      this.message = 'Generating PDF';
      classes = 'pdf';
      break;
    case 'companies':
      this.message = 'Loading Company Information...';
      break;
    case 'projectTypes':
      this.message = `Loading ${this.textMap.projectType} Information...`;
      break;
    case 'company':
      this.message = 'Loading Company ' + this.props.text;
      break;
    case 'projectType':
      this.message = `Loading ${this.textMap.projectType} ${this.props.text}`;
      break;
    case 'directories':
      this.message = 'Loading Directories...';
      break;
    case 'documents':
      this.message = 'Loading Project Documents...';
      break;
    case 'projects':
      this.message = 'Loading Projects...';
      break;
    case 'project':
      this.message = 'Loading Project: ' + this.props.text;
      break;
    case 'tasks':
      this.message = 'Loading Tasks...';
      break;
    case 'user':
      this.message = 'Loading User Information...';
      break;
    case 'locations':
      this.message = 'Loading Locations Information...';
      break;
    case 'activityLogs':
      this.message = 'Loading Activity Logs...';
      break;
    case 'managerDashboard':
      this.message = 'Loading the Manager Dashboard...';
      break;
    default:
      break;
    }

    if (this.props.message) {
      this.message  = this.props.message;
    }
    return (

      <div className={`splash-screen ${classes}` } >
        <section className="top-section" >
          <img className="loader" src={LoadingImage} alt="loading-icon" />
          <p>{this.message}</p>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    catastrophicError: state.main.catastrophicError,
    dataModel: dataModel,
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js